import React from 'react';
// import {
//   Info as Icon // TODO: select an icon
// } from 'components/icons';

import { Icon } from "semantic-ui-react";

function TheIcon () {
  return <Icon name="map outline" />;
}

export const meta = {
  id: 'DataStructuresMapViewer',
  title: 'DataStructuresMapViewer',
  category: 'Engineering',
  exposes: [],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `The viewer, so you can check your DataStructures and their relations.`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
